
export default {
  name: 'RPHFilterModal',
  components: {
    RPHProductSort: () => import('rph/molecules/RPHProductSort/index.vue'),
    Heading: () => import('~/components/atoms/Heading.vue'),
  },
  props: {
    filterIsVisible: {
      type: Boolean,
      default: false,
    },
    isCategoryView: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterIsVisible: function (value) {
      if (value) document.body.style.overflow = 'hidden'
      else document.body.style.overflow = 'visible'
    },
  },
  beforeDestroy() {
    document.body.style.overflow = 'visible'
  },
}
